import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

export const Hero = () => {
  const trustBullets = [
    "Industry-Leading Collection Rate",
    "Comprehensive Tenant Screening",
    "Average 15% Rent Increase",
    "24/7 Maintenance Response",
  ];

  return (
    <section className="relative overflow-hidden">
      {/* Background with image and overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1669070564746-4f33836de219?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxLYW5zYXMlMjBDaXR5JTIwc2t5bGluZXxlbnwwfHx8fDE3NzI0MzM5MjJ8MA&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-background/95 via-background/90 to-background/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-32">
        <div className="text-center mb-6">
          <Badge
            variant="secondary"
            className="mb-6 px-4 py-1.5 text-xs sm:text-sm font-medium"
          >
            Trusted by Property Owners in Johnson County, Kansas
          </Badge>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-6 leading-tight">
            Stop Stressing. Start Profiting.
            <br />
            <span className="text-primary">Expert Kansas Property Management</span>
          </h1>

          <p className="text-lg md:text-xl text-foreground/80 leading-relaxed mb-10 max-w-2xl mx-auto font-medium">
            We handle everything for your Johnson County rentals - from finding perfect tenants to 24/7 maintenance - so you can focus on growing your real estate portfolio.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button
              size="lg"
              data-testid="hero-primary-cta"
              className="w-full sm:w-auto text-lg px-8 py-6 h-auto"
              asChild
            >
              <a href="/get-free-analysis">Get My Free Property Analysis</a>
            </Button>
            <Button
              size="lg"
              variant="outline"
              data-testid="hero-secondary-cta"
              className="w-full sm:w-auto text-lg px-8 py-6 h-auto"
              asChild
            >
              <a href="#contact">View Available Rentals</a>
            </Button>
          </div>

          {/* Trust Strip */}
          <div
            data-testid="hero-trust-strip"
            className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 max-w-3xl mx-auto"
          >
            {trustBullets.map((bullet, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 + index * 0.1, duration: 0.4 }}
                className="flex items-center justify-center gap-2 text-xs sm:text-sm text-foreground/80"
              >
                <CheckCircle2 className="h-4 w-4 text-accent flex-shrink-0" />
                <span className="font-medium">{bullet}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
